import { Routes } from '@angular/router';

import { agencyResolver } from '@core/resolvers/agency.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/complaint.component').then(
        ({ ComplaintPageComponent }) => ComplaintPageComponent,
      ),
    resolve: {
      agency: agencyResolver,
    },
  },
];
